const reportPath = {
  mainRoute: '/reports/*',
  dashboard: '/reports/dashboard',
  salesPaceReports: '/reports/sales-pace-report-table',
  salesPaceReportLineChart: '/reports/sales-pace-report-line-chart',
  salesPerformanceReport: '/reports/sales-performance-report',
  salesPerformanceReportLineChart: '/reports/sales-performance-report-line-chart',
  transactionPerformanceReport: '/reports/transaction-performance-report',
  retentionReport: '/reports/retention-report',
  affiliateSalesSummary: '/reports/affiliate-sales-summary',
  cancellationReasonsOrders: '/reports/cancellationReasons',
  cancellationReasonsSubscriptions: '/reports/cancellationSubscriptionReasons',
  forecastedRebillsReport: '/reports/forecasted-rebills-report',
  conversionReport: '/reports/conversion-report',
  declineResponseReport: '/reports/decline-response-report',
  binRoutingPerformanceReport: '/reports/bin-routing-performance-report',
  varianceReport: '/reports/variance-report',
  cardProcessingReport: '/reports/card-processing-report',
  duplicateCustomerReport: '/reports/duplicate-customer-report',
  chargeBackSummaryReport: '/reports/chargeback-summary-report',
  fraudAnalysisReport: '/reports/fraud-analysis-report',
  fulfillmentSummaryReport: '/reports/fulfillment-summary-report',
  errorsShownToCustomerReport: '/reports/errors-shown-to-customer-report',
  customerPurchaseAttemptsReport: '/reports/customer-purchase-attempts-report',
  revenueSummaryReport: '/reports/revenue-summary-report',
  dtcPopulatedFields: '/reports/dtc-populated-fields',
  capProjectionsReport: '/reports/cap-projections-report',
  reprocessingReport: '/reports/reprocessing-report',
  productsReport: '/reports/products-report',
  negativesReport: '/reports/negatives-report',
  reportError: '/reports-error',
};

export default reportPath;
